export default {"src":"/_next/static/media/logo-desktop-dark.c2550235.svg","height":487,"width":973,"blurWidth":0,"blurHeight":0};